import React from 'react';

import BundleImg from 'main/assets/images/fpvAce/fpv-ace-bundle.webp';

export const Hero = () => {
  return (
    <div className="fpv-ace-hero-container">
      <img
        src={require('main/assets/images/fpvAce/Red_Effect_desktop.webp')}
        alt="Background Red Effect"
        className="fpv-ace-hero-effect"
      />
      <div className="fpv-ace-hero-content">
        <div className="fpv-ace-hero-text">
          <h2 className="fpv-ace-hero-product">
            FPV.ACE
            <br />
          </h2>
          <h1 className="fpv-ace-hero-title">LEARN TO FLY</h1>
        </div>
        <p className="fpv-ace-hero-description">
          Diving into drone flight can be tricky, but FPV.Ace makes it
          effortless, exciting, and accessible for everyone.
        </p>

        <div className="dreamX__discover--button">
          <a
            href="https://shop.orqafpv.com/search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&q=chapters"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            Buy Now
          </a>
        </div>
      </div>
      <img
        src={BundleImg}
        alt="FPV Drone Bundle of the Product"
        className="fpv-ace-hero-img"
        loading="lazy"
      />
    </div>
  );
};
